module.exports = __webpack_public_path__ + "img/ipad-sm-frame-portrait.6ff7cca.png";